import { Slider } from '@mui/material';
import { IRangeSliderProps } from './iRangeSlider';

const RangeSlider = (props: IRangeSliderProps) => {
    return (
        <Slider
            defaultValue={props.defaultValue}
            valueLabelDisplay='auto'
            sx={{
                width: 120,
                color: '#00424E',
                '& .MuiSlider-thumb': {
                    borderRadius: '1px',
                },
            }}
            size='small'
            step={props.step}
            marks
            min={props.min}
            max={props.max}
            name={props.name}
            onChange={props.onChange}
        />
    );
};

export default RangeSlider;
